export enum Experience {
  GettingStarted = "getting_started",
}
